import { supabase } from '@/integrations/supabase/client';

export interface TickerMapping {
  id: string;
  input_symbol: string | null;
  input_isin: string | null;
  resolved_symbol: string;
  notes: string | null;
  created_at: string;
  updated_at: string;
}

const TABLE = 'ticker_mappings';

export function normalizeIsinClient(raw?: string | null): string {
  if (!raw) return '';
  return raw.replace(/[\s\-._/]/g, '').toUpperCase();
}

export async function listMappings(): Promise<TickerMapping[]> {
  const { data, error } = await (supabase as any)
    .from(TABLE)
    .select('*')
    .order('updated_at', { ascending: false });
  if (error) throw error;
  return (data || []) as TickerMapping[];
}

export async function upsertMapping(input: {
  id?: string;
  input_symbol?: string | null;
  input_isin?: string | null;
  resolved_symbol: string;
  notes?: string | null;
}): Promise<TickerMapping> {
  const { data: { session } } = await supabase.auth.getSession();
  if (!session?.user) throw new Error('Not authenticated');

  const payload = {
    user_id: session.user.id,
    input_symbol: input.input_symbol?.trim() ? input.input_symbol.trim().toUpperCase() : null,
    input_isin: input.input_isin?.trim() ? normalizeIsinClient(input.input_isin) : null,
    resolved_symbol: input.resolved_symbol.trim().toUpperCase(),
    notes: input.notes?.trim() || null,
  };

  if (!payload.input_symbol && !payload.input_isin) {
    throw new Error('Provide an input symbol or ISIN');
  }
  if (!payload.resolved_symbol) {
    throw new Error('Resolved Yahoo symbol is required');
  }

  if (input.id) {
    const { data, error } = await (supabase as any)
      .from(TABLE)
      .update(payload)
      .eq('id', input.id)
      .select('*')
      .single();
    if (error) throw error;
    return data as TickerMapping;
  }

  const { data, error } = await (supabase as any)
    .from(TABLE)
    .insert(payload)
    .select('*')
    .single();
  if (error) throw error;
  return data as TickerMapping;
}

export async function deleteMapping(id: string): Promise<void> {
  const { error } = await (supabase as any).from(TABLE).delete().eq('id', id);
  if (error) throw error;
}
